import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  margin: auto;
  text-align: center;
`;

export const Text = styled.p`
  //position: relative;
`;
